<template>
  <!-- 内部ユーザー検索 -->
  <div id="InternalUserSearch">
    <div id="container">
      <masterNavi v-bind:pageid='"UserManage"'></masterNavi>
      <div class="labelTitle lable">ユーザー管理</div>
      <userNavi v-bind:pageid='"InternalUserSearch"'></userNavi>
      <div class="labelTitle lable">内部ユーザー検索</div>
      <!--検索条件 -->
      <div>
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>ID</th>
              <td>
                <input type="text" class="validate" validate="numeric" v-model="searchConditions.userId" name="ID" maxlength="9"/>
              </td>
              <th>権限</th>
              <td>
                <select v-model="searchConditions.kind" name="権限">
                  <option v-for="auth of authorityMaster" :value="auth.code" :key="'s' + auth.code">
                    {{auth.name}}
                  </option>
                </select>
              </td>
              <th>ユーザー名</th><td><input type="text" v-model="searchConditions.name" maxlength="100"/></td>
              <th>メール<br/>アドレス</th><td><input type="text" v-model="searchConditions.mail"  maxlength="100"/></td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
            <b-button class="backButton is-primary" @click="addUser">内部ユーザー追加</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area" v-if="data.length > 0">
          <b-table
            id="internalUserSearchTable"
            :data="data"
            :paginated="true"
            per-page="100"
            pagination-position="both"
            default-sort="userId"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="userId" label="ID" width="100" sortable centered><router-link :to="{name:'InternalUserEdit', params:{searchConditions:searchConditions, uid:props.row.userId}}">{{props.row.userId}}</router-link></b-table-column>
              <b-table-column field="kind" label="権限" width="120" sortable>{{props.row.kind}}</b-table-column>
              <b-table-column field="name" label="ユーザー名" width="150" sortable>{{props.row.name}}</b-table-column>
              <b-table-column field="mail" label="メールアドレス" width="160" sortable>{{props.row.mail}}</b-table-column>
              <b-table-column field="phoneNumber" label="電話番号(直通)" width="100" sortable>{{props.row.phoneNumber}}</b-table-column>
              <b-table-column field="office" label="所属" width="200" sortable>{{props.row.office}}</b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/master/MasterMaintenanceBar";
import userNaviBar from "@/components/mock/philips/master/user/UserNavi";
var data = [];
export default {
  name: "InternalUserSearch",
  methods: {
    doSearch: function() {
      var elements = document.getElementsByClassName("validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        // Web Api Call
        var _this = this;
        var body = this.createBody();
        this.apiCall(
          function(client){
            return client.apis.internalMaintenance.getMaintenanceInternalUserListPOST({
              body:body
            });
          },
          function(result){
            _this.data = result.obj
          },
          function(result){
            _this.showErrorMessage(result);
          }
        );
      }
    },
    addUser: function(){
      this.$router.push({
        name: "InternalUserAdd",
        params: {searchConditions:this.searchConditions}
      });
    },
    createBody: function(){
      let userInfo = {
        userId: this.searchConditions.userId,
        kind:this.searchConditions.kind ? this.searchConditions.kind.toString() : "",
        name:this.searchConditions.name,
        mail:this.searchConditions.mail
      };
      return userInfo;
    }
  },
  data() {
    var authorityMaster = this.getAuthorityMaster();
    authorityMaster = authorityMaster.filter(function(auth) {
      return auth.type == 'inner';
    });
    authorityMaster.unshift({code: ""});
    return {
      authorityMaster:authorityMaster,
      searchConditions:{
        userId:"",
        kind:"",
        name:"",
        mail:""
      },
      data: []
    };
  },
  filters: {},
  components: {
    masterNavi: naviBar,
    userNavi: userNaviBar
  },
  mounted: function() {
    var searchConditions = this.$route.params["searchConditions"];
    if (searchConditions) {
      this.searchConditions = searchConditions;
      this.doSearch();
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width: 100px;
}


</style>


// WEBPACK FOOTER //
// src/components/mock/philips/master/user/InternalUserSearch.vue